import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { Tooltip, Button, Icon } from "antd";
import { withTranslation } from 'react-i18next';

var BurgerBtn = /*#__PURE__*/function (_Component) {
  _inherits(BurgerBtn, _Component);

  var _super = _createSuper(BurgerBtn);

  function BurgerBtn(props) {
    var _this;

    _classCallCheck(this, BurgerBtn);

    _this = _super.call(this, props);

    _this.handleClick = function () {
      var clicked = _this.state.clicked;

      _this.setState({
        clicked: true
      });

      _this.props.setInfoBtn(clicked);
    };

    _this.state = {
      clicked: false
    };
    return _this;
  }

  _createClass(BurgerBtn, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          t = _this$props.t,
          showMenu = _this$props.showMenu;
      return /*#__PURE__*/React.createElement(Tooltip, {
        title: showMenu ? t('btn_Burguer_Menu.closeMenu') : t('btn_Burguer_Menu.openMenu'),
        placement: showMenu ? 'bottom' : 'left'
      }, /*#__PURE__*/React.createElement(Button, {
        size: "small",
        type: "btnMenu",
        onClick: this.handleClick
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "menu"
      })));
    }
  }]);

  return BurgerBtn;
}(Component);

export default withTranslation()(BurgerBtn);